'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dForm$002dButton$002dAction$002dFor$002dDocuments$002dCreate from "./app.pages.-Documents-Create-Page$-Form-Button-Action-For-Documents-Create.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate(transform, lineage) {
  this.Yl = null;
  this.Yk = null;
  this.Yl = transform;
  this.Yk = lineage;
}
export { $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate as $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate };
$p = $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate() {
}
export { $h_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate as $h_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate };
$h_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate)) {
    var x = this.Yl;
    var x$2 = x$0.Yl;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Yk;
      var x$4 = x$0.Yk;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "CreateFormButtonActionForDocumentsCreate";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yl;
  }
  if ((n === 1)) {
    return this.Yk;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "transform";
  }
  if ((n === 1)) {
    return "lineage";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Vt = (function(validatedData, unvalidatedData) {
  return new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dForm$002dButton$002dAction$002dFor$002dDocuments$002dCreate.$c_Lapp_pages_DocumentsCreatePage$FormButtonActionForDocumentsCreate(this.Yl.h(validatedData.v()), this.Yk);
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kt)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate as $isArrayOf_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate };
var $d_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate, "app.pages.DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate", ({
  kt: 1,
  fU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate as $d_Lapp_pages_DocumentsCreatePage$CreateFormButtonActionForDocumentsCreate };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Create-Form-Button-Action-For-Documents-Create.js.map
